<template>
  <div class="home">
    <vs-row vs-justify="center">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-card class="cardx" fixedHeight>
          <div slot="header">
            <h3>
              <vs-divider color="success">Panel De control</vs-divider>
            </h3>
          </div>
          <div>
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <router-link :to="{name:'usuariosform'}"> 
                  <vs-button color="success"  type="flat" icon="person">usuarios
                      </vs-button>
              </router-link>
                
                <vs-button color="primary" type="flat" icon="search"></vs-button>
              </vs-col>
            </vs-row>
          </div>
        
         <router-view />
        </vs-card>
        
      </vs-col>
    </vs-row>

     
  </div>
</template>

<script>
import { nombreCompuesto } from "@/utils/validaciones";
import {
  required,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import prefijos from "@/utils/prefijos";
export default {
  name: "Formulario",
  data() {
    return {
      form: {
        nombre: "",
        pais: +51,
        wspp: null,
        interes: "",
      },
      paises: [],
      sistemaInteres: [
        { name: "Sistema para Ventas en General" },
        { name: "Sistema para Grifos" },
        { name: "Sistema para Restaurantes" },
        { name: "Sistema para Equipos Biométricos" },
        { name: "Sistema para Avícolas" },
        { name: "Sistema para Colegios" },
        { name: "Sistema a Medida" },
        { name: "Otro" },
      ],
    };
  },
  validations: {
    form: {
      nombre: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(25),
        nombreCompuesto,
      },
      pais: {
        required,
      },
      wspp: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(12),
        numeric,
      },
      interes: {
        required,
      },
    },
  },

  computed: {
    erroresNombre() {
      if (!this.$v.form.nombre.$dirty) {
        return "";
      }
      if (!this.$v.form.nombre.required) {
        return "Ingresa tus Nombres Completos";
      }
      if (!this.$v.form.nombre.minLength) {
        return "Ingresa al menos 3 caracteres";
      }
      if (!this.$v.form.nombre.maxLength) {
        return "Ingresa maximo 25 caracteres";
      }
      if (!this.$v.form.nombre.nombreCompuesto) {
        return "Ingresa un Nombre Válido";
      }
    },

    erroresWhatsapp() {
      if (!this.$v.form.wspp.$dirty) {
        return "";
      }
      if (!this.$v.form.wspp.required) {
        return "Whatsapp es Requerido";
      }

      if (!this.$v.form.wspp.minLength) {
        return "Ingresa al menos 9 caracteres";
      }

      if (!this.$v.form.wspp.maxLength) {
        return "Ingresa maximo 12 caracteres";
      }
      if (!this.$v.form.wspp.numeric) {
        return "Ingresa un Whatsapp Válido";
      }
    },

    erroresSistemaInteres() {
      if (!this.$v.form.interes.$dirty) {
        return "";
      }
      if (!this.$v.form.interes.required) {
        return "Sistema de Interes es Requerido";
      }
    },
  },
  created() {
    this.paises = prefijos;
  },
};
</script>
<style>
.cardx {
  margin: 15px;
}
</style>
